import React from 'react';
import PropTypes from 'prop-types';

/**
 * ContentWrap :
 * - Wrapper for RectangleNode Content
 */
export function ContentWrap(props) {
  return (
    <div
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      style={props.style}
      className={props.className}>
      {props.children}
    </div>
  );
}

ContentWrap.propTypes = {
  /**
   * Child components
   */
  children: PropTypes.array,
};

ContentWrap.defaultProps = {
  className: '',
};
